<template>
  <v-layout row class="search-field">
    <v-icon class="child">search</v-icon>

    <v-flex grow class="child">
      <!-- 
        TODO: use editable div instead vuetify text field 
        or create own custom text field where we can fix styles 
        after vuetify upgrades 
      -->
      <v-text-field
        v-model="search"
        :label="$t('search_hint')"
        clearable
        single-line
        full-width
        hide-details
        @click:clear="clearSearchFilter"
        ref="field"
      />
    </v-flex>
  </v-layout>
</template>

<style lang="scss">
  .search-field {
    border-radius:20px;
    background-color: var(--search-bar-background);
    margin:0px 16px 3px 16px;
    white-space:nowrap;
    user-select: none;
    text-align: center;   
  }
  .theme--light .search-field {
    border-width:thin; 
    border-style:solid;
    border-color: rgba(0,0,0,.1);
  }

  .search-field .v-input__slot {
    min-height:fit-content !important;
  }

  .search-field .child {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .search-field.row > i {
    margin-left:16px;
  }

  .search-field .v-text-field--full-width.v-text-field--single-line input {
    margin: 0 !important;
  }
  .search-field .v-text-field--full-width .v-label {
    top: 7px !important;
  }
  .search-field .v-text-field.v-text-field--enclosed .v-input__append-inner {
    margin-top: 4px;
  }
</style>

<script> 

  export default {
    name: 'search',
    props: {
      searchFilter: {
        type: String, 
        default: ""
      }
    },
    computed: {
      search: {
        get() { 
          return this.searchFilter
        },
        set(newVal) {
          return this.$emit('update:searchFilter', newVal)
        }
      }
    },
    methods: {   
      clearSearchFilter() {
        this.$nextTick(() => {
          this.$emit('update:searchFilter', '')
        })
      },
      focus() {
        this.$refs.field.focus()
      }
    }
  }
</script>